import React from 'react';
import { ThemeProvider } from './contexts/ThemeContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { ArabicWithEnglishLanding } from './components/ArabicWithEnglishLanding';
import { PolicyPage } from './components/PolicyPage';
import { TermsPage } from './components/TermsPage';
import { ContactPage } from './components/ContactPage';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { PageLayout } from './components/layout/PageLayout';
import { AdminPanel } from './components/admin/AdminPanel';
export function App() {
  return <ThemeProvider data-id="element-0">
      <LanguageProvider data-id="element-1">
        <BrowserRouter data-id="element-2">
          <PageLayout data-id="element-3">
            <Routes data-id="element-4">
              <Route path="/" element={<ArabicWithEnglishLanding data-id="element-6" />} data-id="element-5" />
              <Route path="/privacy" element={<PolicyPage data-id="element-8" />} data-id="element-7" />
              <Route path="/terms" element={<TermsPage data-id="element-10" />} data-id="element-9" />
              <Route path="/contact" element={<ContactPage data-id="element-12" />} data-id="element-11" />
              <Route path="/admin" element={<AdminPanel data-id="element-14" />} data-id="element-13" />
            </Routes>
          </PageLayout>
        </BrowserRouter>
      </LanguageProvider>
    </ThemeProvider>;
}